import {
  GET_UTILITY_BOOKING_DETAILS,
  GET_UTILITY_BOOKING_DETAILS_SUCCESS,
  GET_UTILITY_BOOKING_DETAILS_ERROR,
  GET_UTILITY_BOOKING_DETAILS_EMPTY,
} from '../../actions.js';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const GetUtilityBookingDetails = (state = initialState, action) => {
  switch (action.type) {
    case GET_UTILITY_BOOKING_DETAILS:
      return { ...state, loading: true, data: null, error: null };

    case GET_UTILITY_BOOKING_DETAILS_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case GET_UTILITY_BOOKING_DETAILS_ERROR:
      return { ...state, loading: false, error: action.payload };

    case GET_UTILITY_BOOKING_DETAILS_EMPTY:
      return { ...initialState };

    default:
      return state;
  }
};

export default GetUtilityBookingDetails;
